import { VAnmeldelseUtkast } from "../valideringstyper/domenetyper/anmeldelseUtkast";

const valideringsmeldinger: VAnmeldelseUtkast = {
  anmeldelseType: {
    en: {
      av: "Kan ikke sende inn anmeldelse av denne typen. Vennligst opprett en anmeldelse som en av følgende typer: {{messageParams.values, anmeldelse_type_list_formatter}}",
    },
  },
  samtykkeInformasjon: {
    ikke: {
      null: "Du må svare om du samtykker til innhenting av opplysninger",
    },
    samtykkeInnhentingAvOpplysninger: {
      ikke: {
        null: "Du må svare om du samtykker til innhenting av opplysninger",
      },
    },
  },
  fornaermet: {
    konfliktraadinformasjon: {
      ikke: {
        null: "Du må svare på om fornærmede er villig til å behandle saken i konfliktråd",
      },
      fornaermetVilligTilKonfliktraad: {
        ikke: {
          null: "Du må svare på om fornærmede er villig til å behandle saken i konfliktråd",
        },
      },
    },
    person: {
      ikke: {
        null: "Du må fylle ut fornærmet person",
      },
      anmeldersRelasjonTilFornaermetPerson: {
        ikke: {
          null: "Du må oppgi anmelders relasjon til fornærmede",
        },
      },
      anmeldersRelasjonTilFornaermetPersonAnnenBeskrivelse: {
        ikke: {
          null: "Du må oppgi en beskrivelse av relasjonen til fornærmede",
          blank: "Kan ikke bestå av bare blanke tegn",
        },
        maks: {
          lengde: "For lang beskrivelse av relasjon til fornærmede",
        },
      },
      kontaktopplysninger: {
        ikke: {
          null: "Du må oppgi kontaktopplysninger til fornærmede",
        },
        epost: {
          ikke: {
            null: "Du må oppgi en e-postadresse",
          },
          gyldig: {
            epost: "Du må oppgi en gyldig e-postadresse",
          },
          maks: {
            lengde:
              "E-postadressen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "Du må oppgi et gyldig telefonnummer",
          },
          ikke: {
            null: "Du må oppgi et telefonnummer",
          },
          maks: {
            lengde:
              "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      navn: {
        ikke: {
          null: "Du må oppgi et navn",
        },
        etternavn: {
          ikke: {
            null: "Du må oppgi etternavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        fornavn: {
          ikke: {
            null: "Du må oppgi fornavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        mellomnavn: {
          ikke: {
            null: "Du må oppgi mellomnavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "Du må oppgi fødsels- eller d-nummer",
        },
        gyldig: {
          foedselsEllerDnummer:
            "Dette er ikke et gyldig norsk fødsels- eller d-nummer",
        },
      },
      beskrivelse: {
        maks: {
          lengde: "For lang beskrivelse av fornærmede",
        },
        ikke: {
          blank: "Kan ikke bestå av bare blanke tegn",
        },
      },
    },
    virksomhet: {
      anmeldersRelasjonTilFornaermetVirksomhet: {
        ikke: {
          null: "Du må oppgi anmelders relasjon til virksomheten",
        },
      },
      anmeldersRelasjonTilFornaermetVirksomhetAnnenBeskrivelse: {
        maks: {
          lengde:
            "Beskrivelsen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
        },
        ikke: {
          null: "Du må oppgi annen relasjon til virksomheten",
          blank: "Relasjonen kan ikke bestå av bare blanke tegn",
        },
      },
      ikke: {
        null: "Du må velge hvem som er fornærmet",
      },
      maaFylleUtVirksomhet: "Du må velge hvem som er fornærmet",
      vekterSelskap: {
        maaFylleUtVirksomhet: "Du må velge hvilket vekterselskap du jobber for",
      },
      virksomhetensReferanse: {
        ikke: {
          blank: "Virksomhetens referanse kan ikke bestå av bare blanke tegn",
        },
        maks: {
          lengde:
            "Virksomhetens referanse er for lang, maks lengde er {{messageParams.maxLength}} tegn",
        },
        begrensetTegnsett:
          "Virksomhetens referanse har ugyldig tegn, {{messageParams.ugyldigeTegn}} er ikke tillatt",
      },
      samtykkeVirksomhetKanSeAnmeldelsen: {
        ikke: {
          null: "Du må oppgi om vil sende en kopi av anmeldelsen til virksomheten",
        },
      },
    },
    type: {
      ikke: {
        null: "Du må oppgi hvem du anmelder på vegne av",
      },
      en: {
        av: "Ugyldig valg av type fornærmet",
      },
    },
  },
  vedlegg: {
    metadata: {
      root: {
        maks: {
          size: "Du kan ikke laste opp flere enn {{messageParams.maxSize}} vedlegg",
        },
        passordbeskyttetFil:
          "Filen er passordbeskyttet, vennligst fjern passordet fra filen og prøv igjen",
        forMangeSider:
          "Filen har mer enn 15000 sider, vennligst reduser antall sider og prøv igjen",
        korruptFil:
          "Vi kan ikke behandle filen du har lastet opp. Det kan hjelpe å eksportere filen i et annet format og forsøke igjen",
        duplikat: {
          fil: "Fil med samme navn eller innhold er allerede lastet opp under $t({{propertyPath}}_lokasjon.{{messageParams.kontekst}}). Endre filnavnet eller velg en annen",
          fil_lokasjon: {
            ANMELDELSE: "vedlegg-steg",
            ERSTATNINGSKRAV_VEDLEGG: "erstatningskrav",
            ERSTATNINGSKRAV_FULLMAKT: "fullmakt",
          },
        },
      },
      opplastet: {
        true: "Vedlegget er ikke lastet opp, hvis feilen fortsetter, prøv å laste opp vedlegget på nytt",
      },
      checksum: {
        feilVedOpplasting:
          "Det skjedde en feil ved opplasting av filen, vennligst prøv igjen",
      },
      filendelse: {
        gyldig: {
          mimetype:
            "Filen kan ikke lastes opp fordi filtypen ikke stemmer med innholdet i filen",
          filtype:
            "Vi støtter ikke denne filtypen, filtyper vi støtter er {{AKSEPTERTE_FILER_STRING}}",
        },
      },
      malwareScanStatus: {
        malwareScanIkkeOk:
          "Dette vedlegget ble stoppet i virusscanning og må fjernes for å kunne sende inn anmeldelsen",
      },
      stoerrelse: {
        ikke: {
          tom: "Filen mangler innhold, vennligst velg en fil som ikke er tom",
        },
        filstoerrelse: {
          maks: "Filen er for stor, den kan ikke være større enn {{messageParams.maksFilstoerrelseString}}",
          totalt:
            "Total filstørrelse må være mindre enn {{messageParams.maksFilstoerrelseString}}",
        },
      },
      filnavn: {
        gyldig: {
          verdi: "Filnavnet er ikke gyldig. Unngå å bruke spesialtegn",
        },
        maks: {
          lengde:
            "Filnavnet er for langt, maks lengde er {{messageParams.maxLength}} tegn",
        },
        ikke: {
          blank: "Filnavnet kan ikke bestå av kun blanke tegn",
        },
      },
      opplastetBytes: {
        feilVedOpplasting:
          "Det skjedde en feil ved opplasting av filen, vennligst prøv igjen",
      },
    },
    beskrivelse: {
      maks: {
        lengde:
          "Beskrivelsen av vedlegget er for lang, maks lengde er {{messageParams.maxLength}} tegn",
      },
      ikke: {
        blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
      },
    },
  },
  hendelsestidspunkt: {
    fra: {
      dato: {
        mindre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              now: "Fra-dato kan ikke være senere enn dagens dato og klokkeslett",
            },
          },
        },
        stoerre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              til: "Fra-dato kan ikke være mer enn 50 år tilbake",
            },
          },
        },
      },
      ikke: {
        null: "Du må oppgi dato og tid for når hendelsen startet",
      },
    },
    til: {
      dato: {
        mindre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              now: "Til-dato kan ikke være senere enn dagens dato og klokkeslett",
            },
          },
        },
        stoerre: {
          eller: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              fra: "Til-dato kan ikke være tidligere enn fra-dato",
            },
          },
        },
      },
    },
  },
  experimentalFields: {
    experimentalGjerningsaktorInformasjon: {
      ikke: {
        null: "Du må svare på om du kan hjelpe oss med å identifisere antatt gjerningsperson",
      },
      gjerningsaktorErKjent: {
        ikke: {
          null: "Du må svare på om du kan hjelpe oss med å identifisere antatt gjerningsperson",
        },
      },
      gjerningsaktorer: {
        maks: {
          size: "Du kan ikke legge til mer enn én virksomhet",
        },
        ikke: {
          tom: "Du må legge til hvem du mener har gjort det",
        },
        begrunnelseForInvolvering: {
          ikke: {
            blank: "Begrunnelsen kan ikke bestå av kun tomme tegn",
            null: "Du må begrunne hvorfor du mener gjerningspersonen er involvert",
          },
          maks: {
            lengde:
              "For lang begrunnelse, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        gjerningsvirksomhet: {
          ikke: {
            null: "Du må legge til en virksomhet",
          },
          orgnummer: {
            ikke: {
              null: "Du må oppgi organisasjonsnummer",
            },
          },
          navn: {
            ikke: {
              null: "Du må oppgi navn på virksomheten",
            },
          },
          manuellVirksomhet: {
            navn: {
              ikke: {
                null: "Du må oppgi navn på virksomheten",
                blank: "Virksomhetsnavn kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "Virksomhetsnavnet er for langt, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            informasjonselementer: {
              verdi: {
                mangler: {
                  verdiForInformasjonselement:
                    "Du må fylle inn verdien for dette feltet",
                  verdiForInformasjonselement_EPOST:
                    "Du må oppgi en e-postadresse",
                  verdiForInformasjonselement_TELEFON:
                    "Du må oppgi et telefonnummer",
                  verdiForInformasjonselement_ADRESSE: "Du må oppgi en adresse",
                  verdiForInformasjonselement_NETTSTED:
                    "Du må oppgi et nettsted",
                  verdiForInformasjonselement_ORGNR:
                    "Du må oppgi et organisasjonsnummer",
                  verdiForInformasjonselement_ANNET: "Du må oppgi en verdi",
                },
                gyldig: {
                  epost: "Du må oppgi en gyldig e-postadresse",
                  telefonnummer: "Du må oppgi et gyldig telefonnummer",
                  nettstedsadresse: "Du må oppgi en gyldig nettstedsadresse",
                },
                maks: {
                  lengde:
                    "Verdien er for lang, maks lengde er {{messageParams.maxLength}} tegn",
                },
                ikke: {
                  null: "Du må fylle inn verdien for dette feltet",
                  blank: "Feltet kan ikke bestå av kun blanke tegn",
                },
              },
            },
          },
        },
        gjerningsperson: {
          root: {
            minstEnInfoGjerningsperson:
              "Du må legge til minst én type opplysning",
          },
          personopplysninger: {
            minstEnInfoGjerningsperson:
              "Du må legge til minst én personopplysning",
          },
          ikke: {
            null: "Du må legge til en gjerningsperson",
          },
          foedselsEllerDnummer: {
            ikke: {
              null: "Du må oppgi fødsels- eller d-nummer",
            },
            gyldig: {
              foedselsEllerDnummer:
                "Dette er ikke et gyldig norsk fødsels- eller d-nummer",
            },
          },
          foedselsdato: {
            dato: {
              mindre: {
                eller: {
                  lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
                  lik_comparison: {
                    now: "Fødselsdato kan ikke settes frem i tid",
                  },
                },
              },
            },
          },
          personnavn: {
            ikke: {
              null: "Du må oppgi et navn",
            },
            etternavn: {
              ikke: {
                null: "Du må oppgi etternavn",
                blank: "Kan ikke bestå av bare blanke tegn",
              },
              maks: {
                lengde:
                  "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            fornavn: {
              ikke: {
                null: "Du må oppgi fornavn",
                blank: "Kan ikke bestå av bare blanke tegn",
              },
              maks: {
                lengde:
                  "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            mellomnavn: {
              ikke: {
                null: "Du må oppgi mellomnavn",
                blank: "Kan ikke bestå av bare blanke tegn",
              },
              maks: {
                lengde:
                  "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          ekstraKontaktopplysninger: {
            typeKontaktopplysning: {
              ikke: {
                null: "Du må oppgi type kontaktopplysning",
              },
            },
            verdi: {
              gyldig: {
                telefonnummer: "Du må oppgi et gyldig telefonnummer",
                epost: "Du må oppgi en gyldig e-postadresse",
              },
              ikke: {
                null: "Du må oppgi en kontaktopplysning",
                blank: "Kontaktopplysningen kan ikke bestå av kun tomme tegn",
              },
              maks: {
                lengde:
                  "Kontaktopplysningen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
              },
              mangler: {
                verdiForKontaktopplysning_TELEFONNUMMER:
                  "Du må oppgi et telefonnummer",
                verdiForKontaktopplysning_EPOST: "Du må oppgi en e-postadresse",
                verdiForKontaktopplysning_BRUKERNAVN:
                  "Du må oppgi et brukernavn",
                verdiForKontaktopplysning_ADRESSE: "Du må oppgi en adresse",
                verdiForKontaktopplysning_ANNET: "Du må oppgi en verdi",
                verdiForKontaktopplysning: "Du må oppgi en kontaktopplysning",
              },
            },
            context: {
              ikke: {
                null: "Du må oppgi kontekst for kontaktopplysningen",
                blank: "Konteksten kan ikke bestå av kun tomme tegn",
              },
              maks: {
                lengde:
                  "Konteksten er for lang, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          personBeskrivelse: {
            ikke: {
              blank: "Beskrivelsen kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For lang beskrivelse av gjerningspersonen, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
          gjerningspersonErMyndig: {
            lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
            lik_comparison: {
              foedselsdato: "Alder må samsvare med fødselsdato",
              foedselsnummer: "Alder må samsvare med fødselsnummer",
            },
            ikke: {
              null: "Du må oppgi alder til gjerningspersonen",
            },
          },
          identifiseringsinformasjon: {
            beskrivelse: {
              ikke: {
                blank: "Beskrivelsen kan ikke bestå av kun tomme tegn",
                null: "Du må beskrive hvordan du identifiserte gjerningspersonen",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av fremvist ID, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            ikke: {
              null: "Du må velge en metode for identifisering",
            },
            metode: {
              ikke: {
                null: "Du må velge en metode for identifisering",
              },
            },
          },
          verge: {
            kontaktopplysninger: {
              epost: {
                ikke: {
                  null: "Du må oppgi en e-postadresse",
                },
                gyldig: {
                  epost: "Du må oppgi en gyldig e-postadresse",
                },
                maks: {
                  lengde:
                    "E-postadressen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              telefonnummer: {
                gyldig: {
                  telefonnummer: "Du må oppgi et gyldig telefonnummer",
                },
                ikke: {
                  null: "Du må oppgi et telefonnummer",
                },
                maks: {
                  lengde:
                    "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            personnavn: {
              ikke: {
                null: "Du må oppgi et navn",
              },
              etternavn: {
                ikke: {
                  null: "Du må oppgi etternavn",
                  blank: "Etternavn kan ikke bestå av bare blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              fornavn: {
                ikke: {
                  null: "Du må oppgi fornavn",
                  blank: "Fornavn kan ikke bestå av bare blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              mellomnavn: {
                ikke: {
                  null: "Du må oppgi mellomnavn",
                  blank: "Mellomnavn kan ikke bestå av bare blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            vergeErKontaktet: {
              ikke: {
                null: "Du må svare på om du har kontaktet vergen",
              },
            },
            vergeTilStede: {
              ikke: {
                null: "Du må svare på om vergen kom til stedet",
              },
            },
          },
          oppgitteOpplysninger: {
            personnavn: {
              ikke: {
                null: "Du må oppgi et navn",
              },
              etternavn: {
                ikke: {
                  null: "Du må oppgi etternavn",
                  blank: "Kan ikke bestå av bare blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              fornavn: {
                ikke: {
                  null: "Du må oppgi fornavn",
                  blank: "Kan ikke bestå av bare blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              mellomnavn: {
                ikke: {
                  null: "Du må oppgi mellomnavn",
                  blank: "Kan ikke bestå av bare blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            virksomhetNavn: {
              ikke: {
                blank: "Oppgitt virksomhet kan ikke bestå av bare blanke tegn",
              },
              maks: {
                lengde:
                  "For langt navn for oppgitt virksomhet, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            andreOpplysninger: {
              ikke: {
                blank: "Andre opplysninger kan ikke bestå av bare blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av andre opplysninger, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
        },
      },
    },
  },
  gjerningspersonInformasjon: {
    gjerningspersoner: {
      foedselsdato: {
        dato: {
          mindre: {
            eller: {
              lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
              lik_comparison: {
                now: "Fødselsdato kan ikke settes frem i tid",
              },
            },
          },
        },
      },
      gjerningspersonErMyndig: {
        lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
        lik_comparison: {
          foedselsdato: "Alder må samsvare med fødselsdato",
          foedselsnummer: "Alder må samsvare med fødselsnummer",
        },
        ikke: {
          null: "Du må oppgi alder til gjerningspersonen",
        },
      },
      begrunnelseForInvolvering: {
        ikke: {
          blank: "Begrunnelsen kan ikke bestå av kun tomme tegn",
          null: "Du må begrunne hvorfor du mener gjerningspersonen er involvert",
        },
        maks: {
          lengde:
            "For lang begrunnelse, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      personBeskrivelse: {
        ikke: {
          blank: "Beskrivelsen kan ikke bestå av bare blanke tegn",
        },
        maks: {
          lengde:
            "For lang beskrivelse av gjerningspersonen, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      identifiseringsinformasjon: {
        beskrivelse: {
          ikke: {
            blank: "Beskrivelsen kan ikke bestå av kun tomme tegn",
            null: "Du må beskrive hvordan du identifiserte gjerningspersonen",
          },
          maks: {
            lengde:
              "For lang beskrivelse av fremvist ID, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        ikke: {
          null: "Du må velge en metode for identifisering",
        },
        metode: {
          ikke: {
            null: "Du må velge en metode for identifisering",
          },
        },
      },
      root: {
        minstEnInfoGjerningsperson: "Du må fylle ut minst ett av feltene",
      },
      ikke: {
        tom: "Du må legge til en gjerningsperson",
      },
      kontaktopplysninger: {
        epost: {
          ikke: {
            null: "Du må oppgi en e-postadresse",
          },
          gyldig: {
            epost: "Du må oppgi en gyldig e-postadresse",
          },
          maks: {
            lengde:
              "E-postadressen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "Du må oppgi et gyldig telefonnummer",
          },
          ikke: {
            null: "Du må oppgi et telefonnummer",
          },
          maks: {
            lengde:
              "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      ekstraKontaktopplysninger: {
        typeKontaktopplysning: {
          ikke: {
            null: "Du må oppgi type kontaktopplysning",
          },
        },
        verdi: {
          gyldig: {
            telefonnummer: "Du må oppgi et gyldig telefonnummer",
            epost: "Du må oppgi en gyldig e-postadresse",
          },
          ikke: {
            null: "Du må oppgi en kontaktopplysning",
            blank: "Kontaktopplysningen kan ikke bestå av kun tomme tegn",
          },
          maks: {
            lengde:
              "Kontaktopplysningen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        context: {
          ikke: {
            null: "Du må oppgi kontekst for kontaktopplysningen",
            blank: "Konteksten kan ikke bestå av kun tomme tegn",
          },
          maks: {
            lengde:
              "Konteksten er for lang, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      verge: {
        kontaktopplysninger: {
          epost: {
            ikke: {
              null: "Du må oppgi en e-postadresse",
            },
            gyldig: {
              epost: "Du må oppgi en gyldig e-postadresse",
            },
            maks: {
              lengde:
                "E-postadressen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
          telefonnummer: {
            gyldig: {
              telefonnummer: "Du må oppgi et gyldig telefonnummer",
            },
            ikke: {
              null: "Du må oppgi et telefonnummer",
            },
            maks: {
              lengde:
                "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
        },
        personnavn: {
          ikke: {
            null: "Du må oppgi et navn",
          },
          etternavn: {
            ikke: {
              null: "Du må oppgi etternavn",
              blank: "Kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
          fornavn: {
            ikke: {
              null: "Du må oppgi fornavn",
              blank: "Kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
          mellomnavn: {
            ikke: {
              null: "Du må oppgi mellomnavn",
              blank: "Kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
        },
        vergeErKontaktet: {
          ikke: {
            null: "Du må svare på om du har kontaktet vergen",
          },
        },
        vergeTilStede: {
          ikke: {
            null: "Du må svare på om vergen kom til stedet",
          },
        },
      },
      personnavn: {
        ikke: {
          null: "Du må oppgi et navn",
        },
        etternavn: {
          ikke: {
            null: "Du må oppgi etternavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        fornavn: {
          ikke: {
            null: "Du må oppgi fornavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        mellomnavn: {
          ikke: {
            null: "Du må oppgi mellomnavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "Du må oppgi fødsels- eller d-nummer",
        },
        gyldig: {
          foedselsEllerDnummer:
            "Dette er ikke et gyldig norsk fødsels- eller d-nummer",
        },
      },
      harVergesKontaktinformasjon: {
        ikke: {
          null: "Du må svare på om du har kontaktinformasjonen til vergen",
        },
      },
    },
    gjerningspersonErKjent: {
      ikke: {
        null: "Du må svare på om du kan hjelpe oss med å identifisere antatt gjerningsperson",
      },
    },
  },
  vitneInformasjon: {
    andreVitner: {
      foedselsdato: {
        dato: {
          mindre: {
            eller: {
              lik: "$t({{propertyPath}}_comparison.{{messageParams.comparison}})",
              lik_comparison: {
                now: "Fødselsdato kan ikke settes frem i tid",
              },
            },
          },
        },
      },
      personBeskrivelse: {
        ikke: {
          blank: "Beskrivelsen kan ikke bestå av bare blanke tegn",
        },
        maks: {
          lengde:
            "For lang beskrivelse av vitne, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      ikke: {
        tom: "Det må være minst ett vitne",
      },
      root: {
        minstEnInfoVitne:
          "Du må fylle ut minst ett av feltene om den som er vitne",
      },
      kontaktopplysninger: {
        epost: {
          ikke: {
            null: "Du må oppgi en e-postadresse",
          },
          gyldig: {
            epost: "Du må oppgi en gyldig e-postadresse",
          },
          maks: {
            lengde:
              "E-postadressen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        telefonnummer: {
          gyldig: {
            telefonnummer: "Du må oppgi et gyldig telefonnummer",
          },
          ikke: {
            null: "Du må oppgi et telefonnummer",
          },
          maks: {
            lengde:
              "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      personnavn: {
        ikke: {
          null: "Du må oppgi et navn",
        },
        etternavn: {
          ikke: {
            null: "Du må oppgi etternavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt etternavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        fornavn: {
          ikke: {
            null: "Du må oppgi fornavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt fornavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
        mellomnavn: {
          ikke: {
            null: "Du må oppgi mellomnavn",
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For langt mellomnavn, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      foedselsEllerDnummer: {
        ikke: {
          null: "Du må oppgi fødsels- eller d-nummer",
        },
        gyldig: {
          foedselsEllerDnummer:
            "Dette er ikke et gyldig norsk fødsels- eller d-nummer",
        },
      },
    },
    andreErVitne: {
      ikke: {
        null: "Du må svare på om du har kontaktinformasjonen til andre vitner",
      },
    },
    anmelderErVitne: {
      ikke: {
        null: "Du må svare på om du selv var vitne til hendelsen",
      },
    },
  },
  hendelsesbeskrivelse: {
    handlinger: {
      tyveri: {
        gjenstander: {
          harForsikring: {
            ikke: {
              null: "Du må svare på om du har forsikring",
            },
          },
          forsikring: {
            ikke: {
              null: "Du må fylle ut forsikringsinformasjon",
            },
            forsikringsselskap: {
              maaFylleUtVirksomhet:
                "Du må oppgi hvilken virksomhet som har forsikret gjenstanden",
            },
            polisenummer: {
              ikke: {
                null: "Du må oppgi polisenummer",
                blank: "Du må oppgi polisenummer",
              },
              maks: {
                lengde:
                  "Polisenummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          handelsvarer: {
            varer: {
              antall: {
                stoerre: {
                  enn: "Antall må være større enn {{messageParams.value}}",
                },
                ikke: {
                  null: "Du må oppgi antall",
                },
              },
              pris: {
                ikke: {
                  null: "Du må angi pris på gjenstanden",
                },
                stoerre: {
                  eller: {
                    lik: "Prisen må være større enn eller lik {{messageParams.value}}",
                  },
                },
              },
              navn: {
                ikke: {
                  null: "Du må angi gjenstand",
                  blank: "Gjenstand kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde: "Gjenstandnavnet er for langt",
                },
              },
              ikke: {
                tom: "Du må legge til en gjenstand",
                null: "Du må legge til en gjenstand",
              },
            },
          },
          kjoeretoey: {
            kjoeretoeyInfo: {
              aarsmodell: {
                stoerre: {
                  enn: "Årsmodellen må være større enn {{messageParams.value}}",
                },
                ikke: {
                  null: "Du må oppgi årsmodellen til kjøretøyet",
                },
              },
              farge: {
                ikke: {
                  blank: "Farge kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "Fargebeskrivelsen til kjøretøyet er for lang, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              merke: {
                ikke: {
                  null: "Du må oppgi merket til kjøretøyet",
                  blank: "Merke kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "Merket på kjøretøyet er for langt, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              modell: {
                ikke: {
                  blank: "Modell kan ikke bestå av kun blanke tegn",
                  null: "Du må oppgi modellen til kjøretøyet",
                },
                maks: {
                  lengde:
                    "Modellnavnet på kjøretøyet er for langt, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              kjoeretoeyType: {
                ikke: {
                  null: "Du må oppgi type kjøretøy",
                },
              },
              understellsnummer: {
                ikke: {
                  blank:
                    "Understellsnummeret kan ikke bestå av kun blanke tegn",
                  null: "Du må oppgi understellsnummeret",
                },
                maks: {
                  lengde:
                    "For langt understellsnummer, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            utenlandskRegistreringsnummer: {
              registreringsland: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank: "Registreringsland kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              registreringslandIsoAlpha3: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank: "Registreringsland kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              registreringsnummer: {
                ikke: {
                  null: "Du må oppgi registreringsnummer",
                  blank:
                    "Registreringsnummer kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            norskRegistreringsnummer: {
              ikke: {
                null: "Du må søke etter registreringsnummeret",
                blank: "Registreringsnummer kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          beskrivelse: {
            ikke: {
              blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
              null: "Du må oppgi en beskrivelse av gjenstanden",
            },
            maks: {
              lengde:
                "For lang beskrivelse av gjenstanden, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
          ikke: {
            tom: "Du må legge til stjålne gjenstander",
            null: "Du må oppgi en eller flere gjenstander",
          },
          kjennemerke: {
            antallSkilt: {
              ikke: {
                null: "Du må oppgi antall skilt",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "Du må oppgi kjennemerke",
              },
              min: {
                lengde:
                  "For kort kjennemerke, minimum lengde er {{messageParams.minLength}} tegn",
              },
              maks: {
                lengde:
                  "For langt kjennemerke, maksimum lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          gjenstandType: {
            ikke: {
              null: "Du må oppgi en gjenstandstype",
            },
          },
          mobiltelefon: {
            telefonnummer: {
              gyldig: {
                telefonnummer: "Du må oppgi et gyldig telefonnummer",
              },
              ikke: {
                null: "Du må oppgi et telefonnummer",
              },
              maks: {
                lengde:
                  "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merke",
                blank: "Du må oppgi merke",
              },
              maks: {
                lengde:
                  "For langt merkenavn, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            modell: {
              ikke: {
                null: "Du må oppgi modell",
                blank: "Modell kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For langt modellnavn, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            teleselskap: {
              ikke: {
                blank: "Teleselskap kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For langt teleselskap, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            imei: {
              ikke: {
                blank: "IMEI kan ikke bestå av kun blanke tegn",
              },
              gyldig: {
                imei: "IMEI er ikke gyldig",
              },
              maks: {
                lengde: "For langt IMEI nummer",
              },
              min: {
                lengde: "For kort IMEI nummer",
              },
              ugyldig: {
                moenster: "IMEI kan bare inneholde tall",
              },
            },
          },
          fartoy: {
            watercraftIdentificationNumber: {
              ugyldigWIN: "Du må oppgi gyldig WIN",
            },
            lengde: {
              ikke: {
                null: "Du må oppgi lengden til fartøyet",
              },
              stoerre: {
                eller: {
                  lik: "Fartøyet må være større enn eller lik {{messageParams.value}}",
                },
              },
              maks: {
                lengde: "For langt fartøy",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket til fartøyet",
              },
              maks: {
                lengde: "Merket på fartøyet er for langt",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "Du må oppgi registreringsnummeret til fartøyet",
              },
              maks: {
                lengde: "Registreringsnummeret er for langt",
              },
            },
            skrogtype: {
              ikke: {
                null: "Du må oppgi skrogtype til fartøyet",
              },
            },
            type: {
              ikke: {
                null: "Du må oppgi typen på fartøyet",
              },
            },
            modell: {
              maks: {
                lengde: "Modellnavnet på fartøyet er for langt",
              },
            },
          },
          sykkel: {
            merke: {
              ikke: {
                null: "Du må oppgi merke på sykkelen",
                blank: "Merke kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "Merket på sykkelen er for langt, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            modell: {
              ikke: {
                blank: "Modell kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "Modellnavnet på sykkelen er for langt, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            type: {
              ikke: {
                null: "Du må oppgi typen på sykkelen",
              },
            },
            rammenummer: {
              ikke: {
                blank: "Rammenummer kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "Rammenummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          pris: {
            ikke: {
              null: "Du må oppgi pris på det som er stjålet",
            },
            lik: "Prisen må være lik {{messageParams.value}}",
            stoerre: {
              eller: {
                lik: "Prisen må være større eller lik {{messageParams.value}}",
              },
            },
          },
          elektronikk: {
            type: {
              ikke: {
                null: "Du må oppgi typen på elektronikken",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket på elektronikken",
                blank: "Merke kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde: "Merke på elektronikken er for langt",
              },
            },
            modell: {
              ikke: {
                null: "Du må oppgi modellen på elektronikken",
                blank: "Modell kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde: "Modellnavnet på elektronikken er for langt",
              },
            },
            serienummer: {
              ikke: {
                blank: "Serienummer kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde: "Serienummeret er for langt",
              },
            },
          },
          verktoy: {
            type: {
              ikke: {
                null: "Du må oppgi typen på verktøyet",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket på verktøyet",
                blank: "Merke kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde: "Merke på verktøyet er for langt",
              },
            },
            modell: {
              ikke: {
                null: "Du må oppgi modellen på verktøyet",
                blank: "Modell kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde: "Modellnavnet på verktøyet er for langt",
              },
            },
            serienummer: {
              ikke: {
                blank: "Serienummer kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde: "Serienummeret er for langt",
              },
            },
          },
        },
      },
      skadeverk: {
        gjenstander: {
          kjoeretoey: {
            kjoeretoeyInfo: {
              aarsmodell: {
                stoerre: {
                  enn: "Årsmodellen må være større enn {{messageParams.value}}",
                },
                ikke: {
                  null: "Du må oppgi årsmodellen til kjøretøyet",
                },
              },
              farge: {
                ikke: {
                  blank: "Farge kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "Fargebeskrivelsen til kjøretøyet er for lang, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              merke: {
                ikke: {
                  null: "Du må oppgi merket til kjøretøyet",
                  blank: "Merke kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "Merket på kjøretøyet er for langt, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              modell: {
                ikke: {
                  blank: "Modell kan ikke bestå av kun blanke tegn",
                  null: "Du må oppgi modellen til kjøretøyet",
                },
                maks: {
                  lengde:
                    "Modellnavnet på kjøretøyet er for langt, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              kjoeretoeyType: {
                ikke: {
                  null: "Du må oppgi type kjøretøy",
                },
              },
              understellsnummer: {
                ikke: {
                  blank:
                    "Understellsnummeret kan ikke bestå av kun blanke tegn",
                  null: "Du må oppgi understellsnummeret",
                },
                maks: {
                  lengde:
                    "For langt understellsnummer, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            utenlandskRegistreringsnummer: {
              registreringsland: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank: "Registreringsland kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              registreringslandIsoAlpha3: {
                ikke: {
                  null: "Du må oppgi registreringsland",
                  blank: "Registreringsland kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt registreringsland, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              registreringsnummer: {
                ikke: {
                  null: "Du må oppgi registreringsnummer",
                  blank:
                    "Registreringsnummer kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
            norskRegistreringsnummer: {
              ikke: {
                null: "Du må søke etter registreringsnummeret",
                blank: "Registreringsnummer kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For langt registreringsnummer, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          beskrivelse: {
            ikke: {
              blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
              null: "Du må oppgi en beskrivelse av skadeverket",
            },
            maks: {
              lengde:
                "For lang beskrivelse av skadeverket, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
          ikke: {
            tom: "Du må legge til ødelagte gjenstander",
            null: "Du må oppgi en eller flere gjenstander",
          },
          gjenstandType: {
            ikke: {
              null: "Du må oppgi en gjenstandstype",
            },
          },
          fartoy: {
            watercraftIdentificationNumber: {
              ugyldigWIN: "Du må oppgi gyldig WIN",
            },
            lengde: {
              ikke: {
                null: "Du må oppgi lengden til fartøyet",
              },
              stoerre: {
                eller: {
                  lik: "Fartøyet må være større enn eller lik {{messageParams.value}}",
                },
              },
              maks: {
                lengde: "For langt fartøy",
              },
            },
            merke: {
              ikke: {
                null: "Du må oppgi merket til fartøyet",
              },
              maks: {
                lengde: "Merket på fartøyet er for langt",
              },
            },
            registreringsnummer: {
              ikke: {
                null: "Du må oppgi registreringsnummeret til fartøyet",
              },
              maks: {
                lengde: "Registreringsnummeret er for langt",
              },
            },
            skrogtype: {
              ikke: {
                null: "Du må oppgi skrogtype til fartøyet",
              },
            },
            type: {
              ikke: {
                null: "Du må oppgi typen på fartøyet",
              },
            },
            modell: {
              maks: {
                lengde: "Modellnavnet på fartøyet er for langt",
              },
            },
          },
          formuestap: {
            ikke: {
              null: "Du må oppgi verdien på det som er ødelagt",
            },
            stoerre: {
              eller: {
                lik: "Verdien må være større enn eller lik {{messageParams.value}}",
              },
            },
          },
        },
      },
      innbrudd: {
        beskrivelse: {
          ikke: {
            blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
            null: "Du må oppgi en beskrivelse av innbruddet",
          },
          maks: {
            lengde:
              "For lang beskrivelse av hendelsen, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      bedrageri: {
        bedragerimetode: {
          ikke: {
            null: "Du må oppgi en bedragerimetode",
          },
          innledendeKontakt: {
            ikke: {
              null: "Du må svare på hvordan du først kom i kontakt med svindleren",
            },
            beskrivelse: {
              ikke: {
                null: "Du må svare på hvordan du først kom i kontakt med svindleren",
                blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          hvaSkjeddeBedrageriMetode: {
            ikke: {
              null: "Du må svare på hva som skjedde i bedrageriet",
            },
            moettSvindlerFysisk: {
              ikke: {
                null: "Du må svare på om du møtte svindleren fysisk",
              },
            },
            harDuMottattLenke: {
              ikke: {
                null: "Du må svare på om du har mottatt en lenke",
              },
            },
            lenke: {
              ikke: {
                null: "Du må oppgi hvilken lenke du har mottatt",
                blank: "Lenken kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang lenke, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            harInstallertProgramEllerApp: {
              ikke: {
                null: "Du må svare på om du har installert et program eller en app",
              },
            },
            hvilketProgramEllerApp: {
              ikke: {
                null: "Du må oppgi et program eller app",
                blank: "Program eller app kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av program eller app, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            paaHvilkenEnhet: {
              ikke: {
                null: "Du må velge et av alternativene",
              },
            },
          },
        },
        tilegnedeVerdier: {
          ikke: {
            null: "Du må svare på hva svindlerne har fått tak i",
            tom: "Du må svare på hva svindlerne har fått tak i",
          },
          type: {
            ikke: {
              null: "Du må svare på hva svindlerne har fått tak i",
            },
          },
          annenTilegnetVerdi: {
            ikke: {
              null: "Du må svare på hvilken annen verdi svindleren har fått tak i",
            },
            beskrivelse: {
              ikke: {
                null: "Du må beskrive hvilken annen verdi svindleren har fått tak i",
                blank:
                  "Du må beskrive hvilken annen verdi svindleren har fått tak i",
              },
              maks: {
                lengde:
                  "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
            sum: {
              ikke: {
                null: "Du må svare på verdi svindleren har fått tak i",
              },
              stoerre: {
                eller: {
                  lik: "Summen må være større eller lik {{messageParams.value}}",
                },
              },
            },
          },
          personinformasjon: {
            ikke: {
              null: "Du må legge til personinformasjon",
            },
            personinformasjonTypeListe: {
              ikke: {
                null: "Du må svare på hva svindlerne har fått tak i",
                tom: "Du må svare på hva svindlerne har fått tak i",
              },
            },
            annetBeskrivelse: {
              ikke: {
                null: "Du må beskrive hva slags personinformasjon svindlerne har fått tak i",
                blank:
                  "Hva slags personinformasjon svindlerne har fått tak i kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av hva slags personinformasjon svindlerne har fått tak i, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          kode: {
            ikke: {
              null: "Du må legge til kode",
            },
            beskrivelse: {
              ikke: {
                null: "Du må svare på hva koden var til",
                blank: "Hva koden var til kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av hva koden var til, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          passord: {
            ikke: {
              null: "Du må legge til passord",
            },
            beskrivelse: {
              ikke: {
                null: "Du må svare på hva passordet var til",
                blank:
                  "Hva passordet var til kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av hva passordet var til, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          fysiskId: {
            ikke: {
              null: "Du må legge til fysisk ID",
            },
            fysiskIdTypeListe: {
              ikke: {
                null: "Du må svare på hva slags fysisk ID svindlerne har fått tak i",
                tom: "Du må svare på hva slags fysisk ID svindlerne har fått tak i",
              },
            },
            annetBeskrivelse: {
              ikke: {
                null: "Du må beskrive hva slags fysisk ID svindlerne har fått tak i",
                blank:
                  "Hva slags fysisk ID svindlerne har fått tak i kan ikke bestå av kun blanke tegn",
              },
              maks: {
                lengde:
                  "For lang beskrivelse av hva slags fysisk ID svindlerne har fått tak i, maks lengde er {{messageParams.maxLength}} tegn",
              },
            },
          },
          penger: {
            ikke: {
              null: "Du må legge til en transaksjon",
              tom: "Du må legge til en transaksjon",
            },
            fratattSum: {
              ikke: {
                null: "Du må svare på hvor mye du ble fratatt",
              },
              stoerre: {
                eller: {
                  lik: "Summen må være større eller lik {{messageParams.value}}",
                },
              },
            },
            overforing: {
              ikke: {
                null: "Overføring kan ikke være null",
              },
              type: {
                ikke: {
                  null: "Du må svare på hvordan du ble fratatt penger",
                },
              },
              kontooverforing: {
                ikke: {
                  null: "Du må legge til en kontooverføring",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi et gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummere",
                  },
                  ikke: {
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                    null: "Du må svare på hvilken konto pengene ble trukket fra",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                tilKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi et gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummere",
                  },
                  ikke: {
                    null: "Du må svare på hvilken konto pengene gikk til",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                    lik: {
                      verdi: "Fra konto og til konto kan ikke være like",
                    },
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "Du må svare på hvilken bank pengene ble tatt fra",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
              },
              vippsoverforing: {
                ikke: {
                  null: "Du må legge til en Vipps-overføring",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi et gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummere",
                  },
                  ikke: {
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                fraTelefonnummer: {
                  gyldig: {
                    telefonnummer: "Du må oppgi et gyldig telefonnummer",
                  },
                  ikke: {
                    null: "Du må svare på hvilket telefonnummer pengene gikk fra",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                tilTelefonnummer: {
                  gyldig: {
                    telefonnummer: "Du må oppgi et gyldig telefonnummer",
                  },
                  ikke: {
                    null: "Du må svare på hvilket telefonnummer pengene gikk til",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                    lik: {
                      verdi:
                        "Fra telefonnummer og til telefonnummer kan ikke være like",
                    },
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "Du må svare på hvilken bank pengene ble tatt fra",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                mottaker: {
                  ikke: {
                    null: "Du må oppgi navn på mottaker",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
              },
              kryptooverforing: {
                ikke: {
                  null: "Du må legge til en krypto-overføring",
                },
                valuta: {
                  ikke: {
                    null: "Du må oppgi hvilken kryptovaluta som ble overført",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                belop: {
                  ikke: {
                    null: "Du må oppgi beløp for krypto-overføringen",
                  },
                  stoerre: {
                    enn: "Beløpet må være større enn {{messageParams.value}}",
                  },
                },
                fraAdresse: {
                  ikke: {
                    null: "Du må svare på hvilken kryptovaluta-adresse pengene gikk fra",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                tilAdresse: {
                  ikke: {
                    null: "Du må svare på hvilken kryptovaluta-adresse pengene gikk til",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                vekslingstjeneste: {
                  ikke: {
                    null: "Du må svare på hvilken vekslingstjeneste som ble benyttet",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                transaksjonsId: {
                  ikke: {
                    null: "Du må oppgi transaksjons-ID",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
              },
              kortbetaling: {
                ikke: {
                  null: "Du må legge til en kortbetaling",
                },
                fraKontonummer: {
                  gyldig: {
                    kontonummer:
                      "Du må oppgi et gyldig norsk kontonummer eller IBAN/BIC for internasjonale kontonummere",
                  },
                  ikke: {
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                kortnummer: {
                  gyldig: {
                    kortnummer: "Du må oppgi et gyldig kortnummer",
                  },
                  ikke: {
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                fraBank: {
                  ikke: {
                    null: "Du må svare på hvilken bank pengene ble tatt fra",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
                mottaker: {
                  ikke: {
                    null: "Du må svare på hvem som mottok betalingen",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
              },
              annetoverforing: {
                ikke: {
                  null: "Du må legge til en annen type overføring",
                },
                beskrivelse: {
                  ikke: {
                    null: "Du må beskrive hvordan pengene ble tatt og hvor de gikk",
                    blank: "Teksten kan ikke bestå av kun blanke tegn",
                  },
                  maks: {
                    lengde:
                      "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                  },
                },
              },
            },
            selvOverfort: {
              ikke: {
                null: "Du må svare på om du selv har overført pengene",
              },
              harDuSelvOverfortPengene: {
                ikke: {
                  null: "Du må svare på om du selv har overført pengene",
                },
              },
              overforingFormaal: {
                ikke: {
                  null: "Du må svare på hva formålet med overføringen var",
                },
              },
              annetOverforingFormaalBeskrivelse: {
                ikke: {
                  null: "Du må beskrive hva formålet med overføringen var",
                  blank: "Teksten kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
              erOverforingGodkjentMedPassordEtc: {
                ikke: {
                  null: "Du må svare på om du har godkjent overføringer ved å taste kode eller passord",
                },
              },
            },
            bankenStansetOverforing: {
              ikke: {
                null: "Du må svare på om banken har stanset overføringen",
              },
              harBankenStansetOverforingen: {
                ikke: {
                  null: "Du må svare på om banken har stanset overføringen",
                },
              },
              hvorMyeHarBankenStanset: {
                ikke: {
                  null: "Du må svare på hvor mye banken har stanset",
                },
                stoerre: {
                  enn: "Må være større enn {{messageParams.value}}",
                },
                mindre: {
                  enn: "Må være mindre enn summen på transaksjonen",
                },
              },
            },
            tilbakeforing: {
              ikke: {
                null: "Du må svare på om du har fått pengene tilbake",
              },
              type: {
                ikke: {
                  null: "Du må svare på om du har fått pengene tilbake",
                },
              },
              hvorMyeHarFornaermedeFaattTilbake: {
                ikke: {
                  null: "Du må svare på hvor mye du har fått tilbake",
                },
                stoerre: {
                  enn: "Må være større enn {{messageParams.value}}",
                },
                mindre: {
                  enn: "Må være mindre enn summen på transaksjonen",
                },
              },
              hvemHarFornaermedeFaattPengerFra: {
                ikke: {
                  null: "Du må oppgi hvem du har fått pengene tilbake fra",
                  blank: "Teksten kan ikke bestå av kun blanke tegn",
                },
                maks: {
                  lengde:
                    "For lang tekst, maks lengde er {{messageParams.maxLength}} tegn",
                },
              },
            },
          },
        },
        etterBedrageriet: {
          ikke: {
            null: "Du må forklare hva som skjedde etter bedrageriet",
          },
          vetBankenOmBedrageriet: {
            ikke: {
              null: "Du må svare på om banken vet om hva som har skjedd",
            },
          },
          erFornaermedesKortSperret: {
            ikke: {
              null: "Du må svare på om kortet ditt er sperret",
            },
          },
          erFornaermedesKontoSperret: {
            ikke: {
              null: "Du må svare på om kontoen din er sperret",
            },
          },
        },
      },
      datakrim: {
        hvaSkjedde: {
          ikke: {
            null: "Du må krysse av for minst én beskrivelse",
          },
          datakrimHendelser: {
            ikke: {
              tom: "Du må krysse av for minst én beskrivelse",
              null: "Du må krysse av for minst én beskrivelse",
            },
          },
          beskrivelse: {
            ikke: {
              null: "Du må beskrive kort hva som har skjedd",
              blank: "Kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
        },
        dataPaAvveie: {
          ikke: {
            null: "Du må svare på om du tror at data er på avveie",
          },
          svar: {
            ikke: {
              null: "Du må svare på om du tror at data er på avveie",
            },
          },
          beskrivelse: {
            ikke: {
              null: "Du må forklare hvorfor du tror data er på avveie",
              blank: "Kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
        },
        andreMyndigheterVarslet: {
          ikke: {
            null: "Du må svare på om andre virksomheter eller myndigheter er varslet eller involvert",
          },
          svar: {
            ikke: {
              null: "Du må svare på om andre virksomheter eller myndigheter er varslet eller involvert",
            },
          },
          beskrivelse: {
            ikke: {
              null: "Du må svare på hvilke myndigheter eller virksomheter som er varslet eller involvert",
              blank: "Kan ikke bestå av bare blanke tegn",
            },
            maks: {
              lengde:
                "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
            },
          },
        },
        tilleggsinformasjon: {
          ikke: {
            blank: "Kan ikke bestå av bare blanke tegn",
          },
          maks: {
            lengde:
              "For lang tilleggsinformasjon, maks lengde er {{messageParams.maxLength}} tegn",
          },
        },
      },
      ikke: {
        tom: "Du må svare på hva som har skjedd",
      },
    },
    beskrivelse: {
      ikke: {
        blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
        null: "Du må forklare hvordan hendelsen skjedde",
      },
      maks: {
        lengde:
          "For lang beskrivelse av hendelsen, maks lengde er {{messageParams.maxLength}} tegn",
      },
    },
  },
  erstatningskrav: {
    beskrivelseErstatningskrav: {
      ikke: {
        blank: "Beskrivelsen kan ikke bestå av kun blanke tegn",
        null: "Du må beskrive hva du krever erstatning for",
      },
      maks: {
        lengde:
          "For lang beskrivelse av erstatningskrav, maks lengde er {{messageParams.maxLength}} tegn",
      },
    },
    ikke: {
      null: "Du må svare på om du ønsker å reise et erstatningskrav",
    },
    erstatningskravSvarType: {
      ikke: {
        null: "Du må svare på om du ønsker å reise et erstatningskrav",
      },
    },
    fullmakt: {
      ikke: {
        null: "Du må laste opp en fullmakt for å kunne reise erstatningskrav",
      },
    },
  },
  hendelsessted: {
    utenlandskAdresse: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
      },
      landkodeAlpha3: {
        ikke: {
          null: "Du må oppgi et land",
          blank: "Du må oppgi et land",
        },
        maks: {
          lengde:
            "For lang landkode, maks lengde er {{messageParams.maxLength}} tegn",
        },
        landKode: "Ikke gyldig land",
      },
      adresselinje: {
        ikke: {
          blank: "Teksten kan ikke bestå av kun blanke tegn",
        },
        maks: {
          lengde:
            "For lang adresselinje, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      postnummer: {
        ikke: {
          blank: "Postnummeret kan ikke bestå av kun blanke tegn",
        },
        maks: {
          lengde:
            "For langt postnummer, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      poststed: {
        ikke: {
          blank: "Poststedet kan ikke bestå av kun blanke tegn",
        },
        maks: {
          lengde:
            "For langt poststed, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
    },
    ikkeFysiskSted: {
      ikke: {
        null: "Du må beskrive hvor det skjedde",
      },
      beskrivelse: {
        ikke: {
          null: "Du må beskrive hvor det skjedde",
          blank: "Teksten kan ikke bestå av kun blanke tegn",
        },
        maks: {
          lengde:
            "For langt nettsted, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
    },
    matrikkeladresse: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
      },
      validKartverketAdresse: "Klarte ikke validere adressen mot kartverket",
    },
    vegadresse: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
      },
      validKartverketAdresse: "Klarte ikke validere adressen mot kartverket",
    },
    stedsnavn: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
      },
      validKartverketStedsnavn:
        "Klarte ikke validere stedsnavnet mot kartverket",
      beskrivelse: {
        ikke: {
          null: "Du må beskrive hvor det skjedde",
          blank: "Teksten kan ikke bestå av kun blanke tegn",
        },
        maks: {
          lengde:
            "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
    },
    kartpunkt: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
      },
      beskrivelse: {
        ikke: {
          null: "Du må beskrive hvor det skjedde",
          blank: "Teksten kan ikke bestå av kun blanke tegn",
        },
        maks: {
          lengde:
            "For lang beskrivelse, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      koordinat: {
        ikke: {
          null: "Trykk på kartet for å angi hvor det skjedde",
        },
        koordinatUtenforNorge:
          "Punktet ser ut til å være i havet eller utenfor Norges grenser. Velg et punkt på land i Norge.",
        lat: {
          ikke: {
            null: "Trykk på kartet for å angi hvor det skjedde",
          },
          mellom:
            "Breddegraden må være mellom {{messageParams.start}} og {{messageParams.end}}",
        },
        lon: {
          ikke: {
            null: "Trykk på kartet for å angi hvor det skjedde",
          },
          mellom:
            "Lengdegraden må være mellom {{messageParams.start}} og {{messageParams.end}}",
        },
      },
    },
    hendelsesstedValg: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
        lik: {
          verdi: "Du må oppgi et gyldig gjerningssted",
        },
      },
    },
    stedtype: {
      ikke: {
        null: "Du må oppgi et gjerningssted",
      },
    },
  },
  bekreftelseAvAnsvarSomAnmelder: {
    ikke: {
      null: "Du må bekrefte at du har forstått ditt ansvar som melder for å levere anmeldelsen",
    },
    true: "Du må bekrefte at du har forstått ditt ansvar som melder for å levere anmeldelsen",
  },
  anmelder: {
    navn: {
      ikke: {
        null: "Kunne ikke hente navnet ditt fra folkeregisteret",
      },
    },
    kontaktopplysninger: {
      epost: {
        ikke: {
          null: "Du må oppgi en e-postadresse",
        },
        gyldig: {
          epost: "Du må oppgi en gyldig e-postadresse",
        },
        maks: {
          lengde:
            "E-postadressen er for lang, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
      telefonnummer: {
        gyldig: {
          telefonnummer: "Du må oppgi et gyldig telefonnummer",
        },
        ikke: {
          null: "Du må oppgi et telefonnummer",
        },
        maks: {
          lengde:
            "Telefonnummeret er for langt, maks lengde er {{messageParams.maxLength}} tegn",
        },
      },
    },
  },
  maaFylleUtVirksomhet: "Du må velge en virksomhet",
};
export default valideringsmeldinger;
